import { ATC_EXTERNAL_TOGGLE } from 'src/commons/constants';
import { useInternalChromeConfigContext } from 'src/providers/InternalChromeConfigContextProvider';

export const canShowSalesAssistant = (userEmail: string): boolean => {
  const { config: internalChromeConfig } = useInternalChromeConfigContext();
  const { isInternalView } = internalChromeConfig;
  const canShowSalesAssistant: boolean =
    !!isInternalView &&
    !(window.sessionStorage.getItem(ATC_EXTERNAL_TOGGLE) == 'true');

  const isAmazonEmail = userEmail.toLowerCase().includes('amazon.');

  return canShowSalesAssistant && isAmazonEmail;
};

export const createMountProps = (
  amazonAlias: string,
  userName: string,
  chromeConfigContext,
) => {
  const applicationName =
    chromeConfigContext.config.applicationName || 'unknown';
  return {
    userAlias: amazonAlias,
    userName: userName,
    window: window.location.host,
    applicationName: applicationName,
  };
};
